module.exports = __webpack_public_path__ + "img/help_delete_book02.0ac260f5.png";